(function () {
  document.querySelectorAll('[data-dynamic-card-lola]').forEach(function (section) {
    initDynamicCard(section);
  });

  function initDynamicCard(section) {
    var flavorButtons = Array.prototype.slice.call(section.querySelectorAll('[data-dcl-flavor-btn]'));
    var mixtypeButtons = Array.prototype.slice.call(section.querySelectorAll('[data-dcl-mixtype-btn]'));
    var titles = Array.prototype.slice.call(section.querySelectorAll('[data-dcl-title]'));
    var images = Array.prototype.slice.call(section.querySelectorAll('[data-dcl-image]'));
    var descriptions = Array.prototype.slice.call(section.querySelectorAll('[data-dcl-description]'));
    var recipes = Array.prototype.slice.call(section.querySelectorAll('[data-dcl-recipe]'));
    var flavorButtonsWrap = section.querySelector('[data-dcl-flavor-buttons]');
    var flavorThumb = section.querySelector('[data-dcl-flavor-thumb]');

    if (!flavorButtons.length) return;

    // Cápsula deslizante: mide el botón de sabor activo (posición +
    // ancho reales, ya renderizados) y se lo pasa al thumb como
    // transform/width — así encaja exacto sin importar que "ORANGE" y
    // "LEMON" midan distinto. Se vuelve a medir en cada resize, porque
    // el font-size del botón cambia en el breakpoint de 750px (16→17px),
    // lo que cambia su ancho real.
    function positionFlavorThumb() {
      if (!flavorThumb || !flavorButtonsWrap) return;

      var activeBtn = flavorButtons.filter(function (btn) {
        return btn.classList.contains('is-active');
      })[0];
      if (!activeBtn) return;

      flavorThumb.style.width = activeBtn.offsetWidth + 'px';
      flavorThumb.style.transform = 'translateX(' + activeBtn.offsetLeft + 'px)';
    }

    var activeFlavorBtn = flavorButtons.filter(function (btn) {
      return btn.classList.contains('is-active');
    })[0] || flavorButtons[0];
    var currentFlavor = activeFlavorBtn.getAttribute('data-flavor');

    var currentMixtype = null;
    if (mixtypeButtons.length) {
      var activeMixBtn = mixtypeButtons.filter(function (btn) {
        return btn.classList.contains('is-active');
      })[0] || mixtypeButtons[0];
      currentMixtype = activeMixBtn.getAttribute('data-mixtype');
    }

    // "mixtype === null" en la llamada hace que este helper solo filtre
    // por sabor — usado para imagen/título/descripción, que ya no
    // dependen del tipo de mezcla en absoluto.
    function showPanel(list, flavor, mixtype) {
      list.forEach(function (el) {
        var matches = el.getAttribute('data-flavor') === flavor &&
          (mixtype === null || el.getAttribute('data-mixtype') === mixtype);
        el.hidden = !matches;
      });
    }

    function updateButtonGroup(buttons, attr, currentValue) {
      buttons.forEach(function (btn) {
        var isActive = btn.getAttribute(attr) === currentValue;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      });
    }

    function render() {
      updateButtonGroup(flavorButtons, 'data-flavor', currentFlavor);
      if (mixtypeButtons.length) updateButtonGroup(mixtypeButtons, 'data-mixtype', currentMixtype);
      positionFlavorThumb();

      // Parte 1 (sabor): imagen, título y descripción — solo dependen
      // del sabor activo.
      showPanel(images, currentFlavor, null);
      showPanel(titles, currentFlavor, null);
      showPanel(descriptions, currentFlavor, null);

      // Parte 2 (tipo de mezcla): la receta depende de ambos, para
      // poder sustituir el nombre del sabor en el texto.
      showPanel(recipes, currentFlavor, currentMixtype);
    }

    flavorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var flavor = btn.getAttribute('data-flavor');
        if (flavor === currentFlavor) return;
        currentFlavor = flavor;
        render();
      });
    });

    mixtypeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mixtype = btn.getAttribute('data-mixtype');
        if (mixtype === currentMixtype) return;
        currentMixtype = mixtype;
        render();
      });
    });

    // Primera medición sin animación -- si no, el thumb se deslizaría
    // visiblemente desde 0 hasta el sabor activo apenas carga la
    // página, en vez de aparecer ya en su lugar. El atributo se quita
    // en el siguiente frame, así los clics posteriores sí animan.
    if (flavorButtonsWrap) flavorButtonsWrap.setAttribute('data-dcl-thumb-ready', 'false');
    render();
    if (flavorButtonsWrap) {
      window.requestAnimationFrame(function () {
        flavorButtonsWrap.setAttribute('data-dcl-thumb-ready', 'true');
      });
    }

    // El ancho real de cada botón cambia en el breakpoint de 750px (el
    // font-size pasa de 16 a 17px), así que el thumb necesita
    // remedirse ahí -- sin esto, quedaría con el ancho/posición viejos
    // hasta el próximo clic.
    window.addEventListener('resize', positionFlavorThumb);
  }
})();